export const emailjsConfig = {
  // Go to Email Services in EmailJS dashboard and copy the Service ID
  serviceId: 'service_vxtc0is',

  // Go to Email Templates, select your template, and copy the Template ID
  templateId: 'template_a7750sa',

  // Go to Account Settings and copy your Public Key
  publicKey: '5xnfDEFOuf9OciDAG',
}; 